import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { MatNativeDateModule, MAT_DATE_FORMATS } from '@angular/material/core';
import { DATE_FORMATS } from '@toro/common/shared/resources/date-formats';

import { CommonModule } from '@angular/common';
import { RouterModule } from "@angular/router";
import { TradingnoteAsidePanelComponent } from "./tradingnote-aside-panel.component";
import { RegularNoteComponent } from "./components/regular-note/regular-note.component";
import { SinacorNoteComponent } from "./components/sinacor-note/sinacor-note.component";
import { SvgIconModule } from '@toro/common/shared/components/svg-icon/svg-icon.module';
import { MatSlideToggleModule } from '@angular/material';
import { TrSpinnerButtonDirectiveModule } from '@toro/common/shared/directives/tr-spinner-button/tr-spinner-button.module';
import { TrCheckboxModule } from '@toro/common/shared/components/tr-forms-inputs/tr-checkbox/tr-checkbox.module';
import { SuccessDialogComponent } from './components/sinacor-note/dialogs/success-dialog/success-dialog.component';
import { AlertDialogComponent } from './components/sinacor-note/dialogs/alert-dialog/alert-dialog.component';

@NgModule({
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA,
    ],
    imports: [
        SvgIconModule,
        MatSlideToggleModule,
        CommonModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        MatDatepickerModule,
        MatInputModule,
        MatNativeDateModule,
        TrSpinnerButtonDirectiveModule,
        TrCheckboxModule
    ],
    declarations: [
        TradingnoteAsidePanelComponent,
        RegularNoteComponent,
        SinacorNoteComponent,
        SuccessDialogComponent,
        AlertDialogComponent,
    ],
    exports: [
        TradingnoteAsidePanelComponent,
        RegularNoteComponent,
        SinacorNoteComponent,
        SuccessDialogComponent,
        AlertDialogComponent
    ],
    entryComponents: [
        TradingnoteAsidePanelComponent,
        RegularNoteComponent,
        SinacorNoteComponent,
        SuccessDialogComponent,
        AlertDialogComponent
    ],
    providers: [
        { provide: MAT_DATE_FORMATS, useValue: DATE_FORMATS },
    ],
})
export class TradingnoteAsidePanelModule { }
